import { render, staticRenderFns } from "./MobileWearMarket.vue?vue&type=template&id=5fa803c0&scoped=true"
import script from "./MobileWearMarket.vue?vue&type=script&lang=js"
export * from "./MobileWearMarket.vue?vue&type=script&lang=js"
import style0 from "./MobileWearMarket.vue?vue&type=style&index=0&id=5fa803c0&prod&scoped=true&lang=css"
import style1 from "./MobileWearMarket.vue?vue&type=style&index=1&id=5fa803c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa803c0",
  null
  
)

export default component.exports